import React, { useContext } from "react";

import _ from "lodash";

import useVisible from "../../utils/isVisible";
import toast from "../../utils/toast";

import lbl from "../../data/Labels.json";

import AddStudentToClassIcon from "../../icons/add-student-to-class-icon";
import DeleteIcon from "../../icons/delete-icon";
import OptionIcon from "../../icons/option-icon";
import PenIcon from "../../icons/pen-icon";

import { PopUpContext } from "../../contexts/popUpContext";
import EditStudentToClassIcon from "../../icons/edit-student-to-class-icon";
import PrintIcon from "../../icons/print-icon";
import {Link} from "react-router-dom";
import { isFinanceReadOnly } from "../../utils/financeAccess";

const RowOption = (props) => {
  const { Delete, Edit, Print, AddStudentToClass, EditStudentClass, DeleteStudentClass, EditStudent, printStatement , PrintFeeReceipt } = props;
  const { ref, isVisible, setIsVisible } = useVisible(false);
  const { togglePopUp } = useContext(PopUpContext);
  const readOnly = props.readOnly || isFinanceReadOnly();

  const hasVisibleOptions =
    PrintFeeReceipt ||
    Print ||
    printStatement ||
    AddStudentToClass ||
    EditStudentClass ||
    DeleteStudentClass ||
    EditStudent ||
    (!readOnly && Edit) ||
    (!readOnly && Delete);

  const renderDeleteOpt = () => {
    if (readOnly) return null;
    return (
    <li
      onClick={() =>
        togglePopUp({
          form: "delete",
          ...Delete,
        })
      }
    >
      <i>
        <DeleteIcon />
      </i>
      <span>{lbl.Delete}</span>
    </li>
    );
  };

  const renderEditOpt = () => {
    if (readOnly) return null;
    return (
      <li onClick={() => togglePopUp({ ...Edit })}>
        <i>
          <PenIcon />
        </i>
        <span>{lbl.Edit}</span>
      </li>
    );
  };

  const renderAddToClassOpt = () => {
    return (
      <li
        onClick={() =>
          togglePopUp({
            form: "student-to-class",
            student: AddStudentToClass,
            entryYear: props.entryYear,
          })
        }
      >
        <i>
          <AddStudentToClassIcon />
        </i>
        <span>{lbl.AddStudentToClass}</span>
      </li>
    );
  };

  const renderEditClassOpt = () => {
    return (
      <li
        onClick={() =>
          togglePopUp({
            form: "student-to-class",
            student: EditStudentClass,
            entryYear: props.entryYear,
            edit: {id: EditStudentClass.student_id},
          })
        }
      >
        <i>
          <EditStudentToClassIcon />
        </i>
        <span>{lbl.EditStudentToClass}</span>
      </li>
    );
  };

  const renderDeleteClassOpt = () => {
    return (
      <li
        onClick={() =>
          togglePopUp({
            form: "student-to-class",
            student: DeleteStudentClass,
            entryYear: props.entryYear,
            delete: {id: DeleteStudentClass.student_id},
          })
        }
      >
        <i>
          <DeleteIcon />
        </i>
        <span>{lbl.DeleteStudentToClass}</span>
      </li>
    );
  };

  const renderEditStudentOpt = () => {
    return (
      <li
        onClick={() =>
          togglePopUp({
            form: "student-form",
            entryYear: props.entryYear,
            edit: EditStudent,
          })
        }
      >
        <i>
          <PenIcon />
        </i>
        <span>{lbl.Edit}</span>
      </li>
    );
  };

  const renderPrintStatementOpt = () => {
    return (
        <Link to={`/print/account-statement/${printStatement.id}?accountName=${printStatement.name}`} target="_blank" >
            <li>
                <i>
                    <PrintIcon />
                </i>
                <span>{lbl.PrintStatement}</span>
            </li>
        </Link>
    );
  };

  const renderPrintOpt = () => {
    return (
        <Link to={`/print/${Print.route}`} target="_blank" >
            <li>
                <i>
                    <PrintIcon />
                </i>
                <span>{Print.title ?? lbl.Print}</span>
            </li>
        </Link>
    );
  };

  const renderPrintFeeReceipt = () => {
    const {receipt} = PrintFeeReceipt;
    return (
        <Link to={`/print/student-fee-receipt/${receipt.id}`} target="_blank" >
            <li>
                <i>
                    <PrintIcon />
                </i>
                <span>{lbl.PrintFeeReceipt}</span>
            </li>
        </Link>
    );
  };

  return (
    <div className="row-option">
      {hasVisibleOptions && (
        <button onClick={() => setIsVisible(!isVisible)}>
          <OptionIcon />
        </button>
      )}

      {isVisible && (
        <div className="option-container" ref={ref}>
          <ul>
            {EditStudent && renderEditStudentOpt()}
            {PrintFeeReceipt && renderPrintFeeReceipt()}
            {Edit && renderEditOpt()}
            {Delete && renderDeleteOpt()}
            {Print && renderPrintOpt()}
            {AddStudentToClass && renderAddToClassOpt()}
            {EditStudentClass && renderEditClassOpt()}
            {DeleteStudentClass && renderDeleteClassOpt()}
            {printStatement && renderPrintStatementOpt()}
          </ul>
        </div>
      )}
    </div>
  );
};

export default RowOption;
